import { StrictMode } from "react";
import "moment-duration-format";

import "./css/global.scss";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./wdyr";

import App from "./App";

ReactDOM.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
  document.querySelector("#root")
);
